import { Button } from '../../components/ui/button';
import { Card, CardContent, CardFooter, CardHeader } from '../../components/ui/card';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../../components/ui/collapsible';
import PurchaseBatchModal from '../../components/modals/PurchaseBatchModal';
import { ArrowRight, Calendar, Check, ChevronDown, ChevronRight, FileText, Users } from 'lucide-react';
import PDF from '../../../public/Icons/PDF.png';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export function TestSeriesCard({ series }) {
  const iconImageSrc = series.icon || '/placeholder.svg?height=50&width=50';

  const features = series.descriptionPoints || [];
  const hiddenBenefits = series.additionalResources || [];
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [isPurchase, setIsPurchase] = useState(true);

  return (
    <Card className="border rounded-xl overflow-hidden h-full flex flex-col min-w-[280px] max-w-[350px] w-full mx-auto">
      <CardHeader className="-mb-2">
        <div className="flex flex-col gap-2 items-start">
          <div className="flex justify-between w-full">
            <h2 className="text-xl font-bold text-[var(--q3-neutral-default)]">{series.title}</h2>
            <div className="w-12 h-auto rounded-full flex items-start mt-2">
              <img src={iconImageSrc} alt={series.title} />
            </div>
          </div>
        </div>
      </CardHeader>
      <hr className="border-red mx-5" />
      <CardContent className="flex-grow ">
        <div className="space-y-4">
          {series.isScheduleIncluded && (
            <div className="flex items-center gap-2 ">
              <img src={PDF} className="h-auto w-5" alt="PDF icon" />
              <span className="text-[#566376]">Downloadable Schedule Included</span>
            </div>
          )}

          <ul className="space-y-2">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-2">
                <Check className="h-4 w-4 text-[var(--q3-neutral-default)] mt-1 flex-shrink-0" />
                <span className="text-[var(--q3-neutral-default)]">{feature}</span>
              </li>
            ))}
          </ul>

          {hiddenBenefits.length > 0 && (
            <Collapsible className="w-full">
              <CollapsibleTrigger className="flex items-center text-[#364FC7] font-medium cursor-pointer">
                <ChevronDown className="h-4 w-4 mr-1" />+ {hiddenBenefits.length} more benefits
              </CollapsibleTrigger>
              <CollapsibleContent className="mt-2">
                <ul className="space-y-2">
                  {hiddenBenefits.map((benefit, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <Check className="h-4 w-4 text-[var(--q3-neutral-light)] mt-1 flex-shrink-0" />
                      <span className="text-[var(--q3-neutral-light)]">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </CollapsibleContent>
            </Collapsible>
          )}
        </div>
      </CardContent>
      <CardFooter className="flex flex-col gap-3 pt-2">
        <Button
          className="w-full bg-[var(--q3-danger-normal)] rounded-3xl text-[var(--q3-neutral-default_inverted)]"
          onClick={() => {
            setShowModal(true);
            setIsPurchase(true);
          }}
        >
          Join Test Series
          <ArrowRight className="ml-2" />
        </Button>

        <Button
          variant="outline"
          className="w-full rounded-3xl"
          onClick={() => {
            setShowModal(true);
            setIsPurchase(false);
          }}
        >
          View More Details
        </Button>

        {series.studentCountDetails?.showStudentCount && (
          <div className="flex items-center justify-center gap-2 text-[var(--q3-danger-normal)] text-sm w-full">
            <Users className="h-4 w-4" />
            <span>
              {series.studentCountDetails.studentCount}{' '}
              {series.studentCountDetails.textToDisplay || 'Students have already joined'}
            </span>
          </div>
        )}
      </CardFooter>
      {showModal && (
        <PurchaseBatchModal packGroup={series} onClose={() => setShowModal(false)} isPurchase={isPurchase} />
      )}
    </Card>
  );
}
